// Duck for CompleteReturnPage (provider confirms return).
import { storableError } from '../../util/errors';
import { postHandoffTransition } from '../../util/pickupCode';

const FETCH_TX_REQUEST = 'app/CompleteReturnPage/FETCH_TX_REQUEST';
const FETCH_TX_SUCCESS = 'app/CompleteReturnPage/FETCH_TX_SUCCESS';
const FETCH_TX_ERROR = 'app/CompleteReturnPage/FETCH_TX_ERROR';
const SUBMIT_REQUEST = 'app/CompleteReturnPage/SUBMIT_REQUEST';
const SUBMIT_SUCCESS = 'app/CompleteReturnPage/SUBMIT_SUCCESS';
const SUBMIT_ERROR = 'app/CompleteReturnPage/SUBMIT_ERROR';
const SUBMIT_RESET = 'app/CompleteReturnPage/SUBMIT_RESET';

const initialState = {
  transaction: null,
  fetchInProgress: false,
  fetchError: null,
  submitInProgress: false,
  submitError: null,
  submitSuccess: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_TX_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_TX_SUCCESS:
      return { ...state, fetchInProgress: false, transaction: action.payload };
    case FETCH_TX_ERROR:
      return { ...state, fetchInProgress: false, fetchError: action.payload };
    case SUBMIT_REQUEST:
      return { ...state, submitInProgress: true, submitError: null, submitSuccess: false };
    case SUBMIT_SUCCESS:
      return { ...state, submitInProgress: false, submitSuccess: true };
    case SUBMIT_ERROR:
      return { ...state, submitInProgress: false, submitError: action.payload };
    case SUBMIT_RESET:
      return { ...state, submitError: null, submitSuccess: false };
    default:
      return state;
  }
}

export const submitReset = () => ({ type: SUBMIT_RESET });

export const loadData = params => (dispatch, getState, sdk) => {
  dispatch({ type: FETCH_TX_REQUEST });
  return sdk.transactions
    .show({ id: params.id, include: ['customer', 'provider', 'listing', 'booking'] })
    .then(resp => {
      const tx = resp?.data?.data;
      const included = resp?.data?.included || [];
      const byRel = rel => included.find(e => e.id.uuid === rel?.id?.uuid);
      dispatch({
        type: FETCH_TX_SUCCESS,
        payload: {
          ...tx,
          customer: byRel(tx?.relationships?.customer?.data),
          provider: byRel(tx?.relationships?.provider?.data),
          listing: byRel(tx?.relationships?.listing?.data),
          booking: byRel(tx?.relationships?.booking?.data),
        },
      });
      return tx;
    })
    .catch(e => {
      dispatch({ type: FETCH_TX_ERROR, payload: storableError(e) });
      throw e;
    });
};

export const submitCompleteReturn = ({ transactionId, returnPhotoKeys }) => dispatch => {
  dispatch({ type: SUBMIT_REQUEST });
  return postHandoffTransition({
    transactionId,
    transition: 'transition/complete-return',
    orderData: { returnPhotos: returnPhotoKeys },
  })
    .then(r => {
      dispatch({ type: SUBMIT_SUCCESS });
      return r;
    })
    .catch(err => {
      dispatch({ type: SUBMIT_ERROR, payload: storableError(err) });
      throw err;
    });
};
